import { render, staticRenderFns } from "./editActivityPaymentModel.vue?vue&type=template&id=2aabb8d3&scoped=true&"
import script from "./editActivityPaymentModel.vue?vue&type=script&lang=js&"
export * from "./editActivityPaymentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aabb8d3",
  null
  
)

export default component.exports